<template>
  <v-app>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-app-bar flat>
          <v-icon>storage</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;ABM de Productos</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)"
              >
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-app-bar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarList"
                >
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Lista</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>

                <v-flex right>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar por Nombre"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>

                <v-data-table
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :loading="loading"
                  :options.sync="options"
                  v-model="selectedRow"
                  :footer-props="{
                    itemsPerPageOptions: options.rowsPerPageItems,
                  }"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="grey" icon="warning">
                      No se encontraron datos
                    </v-alert>
                  </template>
                  <template v-slot:item="{ item }">
                    <tr @click="viewItem(item)">
                      <td class="text-xs-left">
                        {{ item.tipoProductoDescripcion }}
                      </td>
                      <td class="text-xs-left">{{ item.descripcion }}</td>

                      <td class="text-xs-left">
                        <v-icon
                          small
                          class="mr-2"
                          @click="editItem(item)"
                          v-show="canUpdate"
                          >edit</v-icon
                        >
                        <v-icon
                          small
                          @click="deleteItem(item)"
                          v-show="canDelete"
                          >delete</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
              <v-spacer></v-spacer>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarList + ' lighten-4'"
                >
                  <v-icon>done_all</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Acciones Masivas</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>

                <v-container>
                  <v-row no-gutters align="center">
                    <v-col cols="8" class="body-1">
                      <div>
                        Establecer días de gracia para todos los Productos en
                      </div>
                    </v-col>
                    <v-col cols="1">
                      <v-text-field
                        v-model="diasGraciaMasivo"
                        suffix="Días"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="1"> </v-col>
                    <v-col cols="2">
                      <v-btn
                        @click="setDiasGraciaMasivo"
                        :disabled="
                          !diasGraciaMasivo || !(diasGraciaMasivo >= 0)
                        "
                        >Confirmar</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarDetail"
                >
                  <v-icon>payment</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Detalle</v-toolbar-title
                  >
                  <v-spacer></v-spacer>

                  <v-btn
                    v-if="!editMode"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editItem()"
                    v-show="canCreate"
                  >
                    <v-icon medium>add_circle_outline</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="model.id != null"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editMode = !editMode"
                    v-show="canUpdate"
                  >
                    <v-icon v-if="editMode">cancel</v-icon>
                    <v-icon v-else>edit</v-icon>
                  </v-btn>
                </v-app-bar>
                <v-card-text>
                  <v-form :disabled="!editMode">
                    <v-layout>
                      <v-flex xs4>
                        <v-autocomplete
                          v-model="model.tipoProductoId"
                          :items="tiposProducto"
                          item-text="descripcion"
                          item-value="id"
                          label="Tipo de Producto:"
                          placeholder="Seleccione uno"
                          :disabled="!editMode"
                          :menu-props="{ minWidth: '400' }"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs8>
                        <v-text-field
                          v-model="model.descripcion"
                          label="Descripcion"
                          required
                          :disabled="!editMode"
                          v-validate="'required'"
                          data-vv-name="descripcion"
                          :error-messages="errors.collect('descripcion')"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-container
                      v-if="
                        $store.state.parametrosGenerales.cargosAtrasoPor ==
                        'producto'
                      "
                    >
                      <template
                        v-for="calificacion in model.politicasComerciales"
                      >
                        <v-layout :key="calificacion.id">
                          <v-flex xs8>
                            <v-autocomplete
                              :items="listaPoliticasComerciales"
                              v-model="calificacion.politicaComercialId"
                              item-text="nombre"
                              item-value="id"
                              :label="calificacion.clasificacionParaLista"
                              placeholder="Seleccione una Política"
                              :disabled="!editMode"
                              :menu-props="{ minWidth: '400' }"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </template>
                    </v-container>

                    <!-- <v-layout>
                            
                              <v-flex xs8>
                                  <v-autocomplete v-model="model.politicaComercialId" :items="listaPoliticasComerciales"
                                        item-text="nombre" item-value="id" label="Utiliza un Política Comercial?" placeholder="Seleccione una Política" 
                                        :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                              </v-flex>
                          </v-layout> -->

                    <v-switch
                      label="Aplica Sellado"
                      v-model="model.aplicaSellado"
                      :disabled="!editMode"
                    >
                    </v-switch>

                    <v-switch
                      label="Requiere Documentación"
                      v-model="model.requiereDocumentacion"
                      :disabled="!editMode"
                    >
                    </v-switch>

                    <v-switch
                      label="Requiere Ingreso Cargos Servicio"
                      v-model="model.requiereIngresoCargosServicio"
                      :disabled="!editMode"
                    >
                    </v-switch>

                    <v-flex xs4>
                      <v-text-field
                        v-model="model.diasGracia"
                        label="Días de Gracia"
                        required
                        :disabled="!editMode"
                        v-validate="'required'"
                        data-vv-name="diasGracia"
                        :error-messages="errors.collect('diasGracia')"
                      ></v-text-field>
                      <v-text-field
                        v-if="esProductoAdelanto"
                        v-model="model.tasaMinima"
                        label="Tasa Mínima"
                        required
                        :disabled="!editMode"
                        v-validate="'required'"
                        data-vv-name="tasaMinima"
                        :error-messages="errors.collect('tasaMinima')"
                      ></v-text-field>
                    </v-flex>

                    <v-switch
                      label="Aplica Cargos por Atraso"
                      v-model="model.aplicaCargosPorAtraso"
                      :disabled="!editMode"
                      v-if="
                        $store.state.parametrosGenerales.cargosAtrasoPor ==
                        'producto'
                      "
                    >
                    </v-switch>

                    <app-lista-cargos
                      v-if="
                        $store.state.parametrosGenerales.cargosAtrasoPor ==
                        'producto'
                      "
                      v-show="model.aplicaCargosPorAtraso"
                      propName="listaCargos"
                      :value="model.cargosAtraso"
                      :editMode="editMode"
                      :cargosAtraso="true"
                    >
                    </app-lista-cargos>

                    <v-divider></v-divider>
                    <template v-if="$store.state.debugModeOn">
                      Debug Info:
                      <p></p>

                      Model: {{ model }}
                      <p></p>
                    </template>
                    <v-divider></v-divider>

                    <v-card-actions bottom>
                      <!-- <v-speed-dial direction="right" >
                             <v-btn slot="activator" color="orange" text small v-show="editMode">
                                <v-icon color="orange">touch_app</v-icon>                                
                                Mas Acciones
                              </v-btn>
                              <v-tooltip bottom>
                                <v-btn small text color="green" slot="activator" @click="copiarDomicilio" v-show="editMode">
                                  Copiar Domicilio
                                </v-btn>
                                <v-btn small text color="green" slot="activator" @click="updateStatus" v-show="editMode">
                                    <v-text v-if="model.status.baja">Habilitar</v-text>
                                    <v-text v-else>Deshabilitar</v-text>
                                </v-btn>
                              </v-tooltip>
                            </v-speed-dial>-->

                      <v-spacer></v-spacer>
                      <v-btn
                        color="success"
                        :disabled="!editMode"
                        @click="saveItem"
                        ><v-icon>save</v-icon>Guardar</v-btn
                      >
                    </v-card-actions>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { http } from "@/axios";
import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: "", // valor para búsqueda
      options: {
        // definición de paginación
        sortDesc: [false],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      totalItems: 0, // va afuera de options
      headers: [
        // definición de columnas
        { text: "Tipo", value: "tipoProducto" },
        { text: "Descripcion", value: "descripcion" },
        { text: "Acciones", value: "name", sortable: false },
      ],
      records: [], // registros
      selectedRow: [],
      tiposProducto: [],
      listModelosSMS: [],
      listaPoliticasComerciales: [],
      listCalificacionesPersonas: [],
      model: { cargosAtraso: [] }, // registro para ver/editar
      diasGraciaMasivo: null,
    };
  },
  async created() {
    this.loadTiposProducto();
    this.loadPoliticasComerciales();
    this.loadCalificacionesPersonas();
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    search() {
      this.getItems();
    },
  },
  computed: {
    ...mapGetters([
      "checkCanCreate",
      "checkCanUpdate",
      "checkCanDelete",
      "getActionFromLink",
    ]),
    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    esProductoAdelanto() {
      return (
        this.model.descripcion &&
        this.model.descripcion.includes("ADELANTO PLUS")
      );
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    async getItems() {
      this.loading = true;
      this.$validator.reset();

      try {
        var result = await http.get(
          "productos?descripcion=" +
            this.search +
            "&limit=" +
            this.options.itemsPerPage +
            "&page=" +
            this.options.page +
            "&sortby=" +
            this.options.sortBy +
            "&descending=" +
            (this.options.sortDesc.length > 0
              ? this.options.sortDesc
              : "false"),
        );

        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async resetState() {
      this.$validator.reset();
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true;
      this.resetState();

      try {
        var result = await http.get("productos/" + id);

        this.model = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
    async viewItem(item) {
      if (this.suspend) return;

      this.selectedRow.pop();
      this.selectedRow.push(item);

      await this.getItem(item.id);
      this.editMode = false;
    },
    async clearAndReload() {
      // Clear the data inside of the form
      this.model = { status: {} };
      this.resetState();

      // Refresco la grilla
      await this.getItems();
    },
    async editItem(item) {
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if (!item) await this.getItem(0);
      else await this.getItem(item.id);

      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      console.log(this.model);

      const isUpdate = !(this.model.id === 0);

      await this.$validator.validateAll();

      if (this.errors.items.length > 0) return;

      if (isUpdate) {
        try {
          await http.put("productos", JSON.stringify({ producto: this.model }));
          this.alertSuccess("Los cambios han sido guardados.");
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      } else {
        try {
          console.log(this.model);
          await http.post(
            "productos",
            JSON.stringify({ producto: this.model }),
          );
          this.alertSuccess("Los cambios han sido guardados.");
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }
    },
    async deleteItem(item) {
      if (
        confirm(
          "¿Confirma la eliminación del producto " + item.descripcion + "?",
        )
      ) {
        try {
          var result = await http.delete("productos?id=" + item.id);
          this.alertSuccess("El producto ha sido eliminado.");
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }
    },
    async setDiasGraciaMasivo() {
      if (
        confirm(
          "¿Confirma establecer los dias de gracia en " +
            this.diasGraciaMasivo +
            " para todos los Productos?",
        )
      ) {
        try {
          var result = await http.put(
            "productos/updatemasivo",
            JSON.stringify({
              updateMasivo: {
                tipoProductoId: 0,
                diasGracia: this.diasGraciaMasivo,
              },
            }),
          );
          this.alertSuccess(
            "Se han modificado los Días de Gracia para todos los productos.",
          );
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }
    },
    async loadTiposProducto() {
      this.loading = true;
      try {
        var result = await http.get("tiposproducto");
        this.tiposProducto = result.list;

        Vue.$log.debug(this.tiposProducto);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadPoliticasComerciales() {
      this.loading = true;
      try {
        var result = await http.get("politicascomerciales");
        this.listaPoliticasComerciales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCalificacionesPersonas() {
      this.loading = true;
      try {
        var result = await http.get("tiposcalificacionpersona"); // traigo todas
        this.listCalificacionesPersonas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
